import * as actions from './actions';
import { customDefaultCourses } from '../../helpers/utils';

const initialState = {
    defaultCourses: [],
    upfCourses: [],
    courseDetails: {
        name: '',
        topics: []
    },
    isCourseModalVisible: false,
    isDefaultCoursesLoaded: false,
    selectedCourseId: false,
    savingDefaultCourses: false,
    onSuccessfulSave: false
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_DEFAULT_COURSE_SUCCESS: {
        return { ...state,
            defaultCourses: customDefaultCourses(action.data.defaultCourses),
            upfCourses: customDefaultCourses(action.data.upfCourses),
            isDefaultCoursesLoaded: true,
            onSuccessfulSave: false
        };
    }
    case actions.GET_DEFAULT_COURSE_FAILURE: {
        return { ...state, isDefaultCoursesLoaded: false };
    }
    case actions.SHOW_COURSE_DETAILS: {
        return { ...state, selectedCourseId: action.courseId };
    }
    case actions.HIDE_COURSE_DETAILS: {
        return { ...state, courseDetails: initialState.courseDetails, selectedCourseId: false, isCourseModalVisible: false };
    }
    case actions.FETCH_COURSE_DETAILS_REQUEST: {
        return { ...state, fetchingCourse: true };
    }
    case actions.FETCH_COURSE_DETAILS_SUCCESS: {
        return { ...state, courseDetails: action.courseDetails, fetchingCourse: false, isCourseModalVisible: true };
    }
    case actions.FETCH_COURSE_DETAILS_FAILURE: {
        return { ...state, fetchingCourse: false };
    }
    case actions.SAVE_DEFAULT_COURSE_REQUEST: {
        return { ...state, savingDefaultCourses: true };
    }
    case actions.SAVE_DEFAULT_COURSE_SUCCESS: {
        return { ...state,
            savingDefaultCourses: action.savingDefaultCourses,
            onSuccessfulSave: true,
            isDefaultCoursesLoaded: false
        };
    }
    case actions.SAVE_DEFAULT_COURSE_FAILURE: {
        return { ...state, savingDefaultCourses: action.savingDefaultCourses, onSuccessfulSave: false };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/manage-default-courses/reducer.js